module.exports = __webpack_public_path__ + "static/media/pick_a_make.1b6230b0.png";